import { render, staticRenderFns } from "./DRESelect.vue?vue&type=template&id=c8ea31be"
import script from "./DRESelect.vue?vue&type=script&lang=js"
export * from "./DRESelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports